import React from 'react'
import { ChartBarIcon } from '@phosphor-icons/react'
import styles from './Summary.module.scss'

/**
 * KPI renderer component.
 * Renders summary data as KPI cards/widgets.
 *
 * TODO: Implement full KPI rendering.
 * For now, this is a placeholder that shows the data exists.
 *
 * @param {Object} props
 * @param {Object} props.data - Summary data for KPI view
 */
export const SummaryKPI = ({ data }) => {
    // TODO: Implement full KPI view
    // The KPI view requires integration with the existing KPI rendering logic
    // from the old Explorer component

    if (!data) {
        return (
            <div className={styles.centerContent}>
                <div className={styles.emptyState}>
                    <ChartBarIcon size={48} className={styles.emptyStateIcon} />
                    <span className={styles.emptyStateText}>No KPI data available</span>
                </div>
            </div>
        )
    }

    return (
        <div className={styles.centerContent}>
            <div className={styles.emptyState}>
                <ChartBarIcon size={48} className={styles.emptyStateIcon} />
                <span className={styles.emptyStateText}>
                    KPI view is being implemented. Data has {data?.series?.length || 0} series.
                </span>
            </div>
        </div>
    )
}
